module.exports = __webpack_public_path__ + "img/HoveredGithubIcon.38a72549.svg";